const initialState = {
	chatHistory: []
};

const reducer = (state = initialState) => state;

export { initialState };
export default reducer;
